@if (section(); as s) {
  <app-section-wrapper [id]="s.id" [title]="s.title" [background]="s.background">
    <div class="why-grid stagger">
      @for (item of s.items; track item.title) {
        <div class="why-item">
          <div class="why-item__icon">
            <mat-icon>{{ item.icon }}</mat-icon>
          </div>
          <div class="why-item__text">
            <h3 class="why-item__title">{{ item.title }}</h3>
            <p class="why-item__desc">{{ item.description }}</p>
          </div>
        </div>
      }
    </div>
    <div class="why-cta">
      <app-cta-button
        [label]="s.cta.label"
        variant="primary"
        [fragment]="s.cta.fragment"
      />
    </div>
  </app-section-wrapper>
}
